import s from './floatingRatingBadge.module.scss';

/**
 * Плавающий бейдж «ПроДокторов — участник рейтинга».
 * Живёт в левом-нижнем углу, чтобы стоять над сторонним виджетом «Запись»
 * (тот подгружается вне репо — Yandex/GTM/внешний скрипт).
 * Ссылка внешняя — обычный <a>, не next/image (домен prodoctorov.ru
 * не в remotePatterns у next.config).
 */
export const FloatingRatingBadge = () => {
  return (
    <a
      className={s.badge}
      href="https://prodoctorov.ru/stavropol/lpu/110927-klinika-stavrossmed/?utm_source=widget&utm_medium=referral&utm_campaign=round"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="ПроДокторов — Клиника «СтавРоссМед», Ставрополь"
      title="ПроДокторов — Клиника «СтавРоссМед», Ставрополь"
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src="https://prodoctorov.ru/rating/widget/round/110927/200.png"
        alt="ПроДокторов — Клиника «СтавРоссМед», Ставрополь"
        width={150}
        height={150}
        loading="lazy"
      />
    </a>
  );
};
